import { Theme } from "@aws-amplify/ui-react";

export const lightTheme: Theme = {
  name: "custom-light-theme",
  tokens: {
    colors: {
      background: {
        primary: { value: "#f3f0ff" },
        secondary: { value: "#ffffff" },
      },
      brand: {
        primary: {
          10: { value: "#6a5cff" },
          20: { value: "#f3f0ff" },
          40: { value: "#ffffff" }, //table body background
          60: { value: "#F3F4F6" }, //table header background
          80: { value: "#7b6dff" },
          100: { value: "#ffffff" }, //table background
        },
      },
      font: {
        primary: { value: "#1f1f24" },
        secondary: { value: "#4a4a55" },
        tertiary: { value: "#6b6b76" },
        inverse: { value: "#ffffff" },
      },
      surface: {
        card: { value: "#FFFFFF" },
        page: { value: "#F8FAFC" },
        darkCard: { value: "#16142B" },
        darkPage: { value: "#FFFFFF" }, //status percentage bar progress
        shadow: { value: "rgba(0, 0, 0, 0.1)" },
      },
      text: {
        primary: { value: "#111827" },
        secondary: { value: "#374151" },
        onDark: { value: "#111827" },
      },
      border: {
        primary: { value: "#E5E7EB" },
        secondary: { value: "#D1D1E0" },
      },
      status: {
        ok: { value: "#10B981" },
        stop: { value: "#EF4444" },
        info: { value: "#3B82F6" },
        warn: { value: "#F59E0B" },
      },
      statusBack: {
        ok: { value: "rgba(16,185,129,.12)" },
        stop: { value: "rgba(239,68,68,.12)" },
        info: { value: "#3B82F6" },
        warn: { value: "#F59E0B" },
      },
      statusBack2: {
        ok: { value: "rgba(16, 185, 129, 0.15)" },
        stop: { value: "rgba(239, 68, 68, 0.12)" },
        info: { value: "#3B82F6" },
        warn: { value: "#F59E0B" },
      },
      purple: {
        10: { value: "#F5F3FF" },
        40: { value: "#C4B5FD" },
        60: { value: "#7B66FF" },
        80: { value: "#5B4BDB" },
        100: { value: "#3C2BA8" },
      },
      link: {
        primary: { value: "#4F46E5" },
        hover: { value: "#3730A3" },
        focus: { value: "rgba(123,102,255,.25)" },
      },
      muted: { value: "#4b5563" },
      placeholder: { value: "#6b7280" },
      caret: { value: "#6B7280" },
    },
    fonts: {
      default: { variable: "NunitoSans, system-ui, sans-serif" },
    },
    radii: {
      small: { value: "5px" },
      medium: { value: "12px" },
      large: { value: "20px" },
    },
    components: {
      authenticator: {
        router: {
          backgroundColor: { value: "{colors.background.secondary}" },
          boxShadow: { value: "none" },
        },
      },
      card: {
        backgroundColor: { value: "{colors.background.secondary}" },
        borderColor: { value: "{colors.border.primary}" },
        borderRadius: { value: "{radii.medium}" },
        padding: { value: "{space.medium}" },
      },
      fieldcontrol: {
        borderRadius: { value: "{radii.medium}" },
        borderColor: { value: "{colors.border.primary}" },
        _disabled: {
          borderColor: { value: "#e6e3ff" },
          backgroundColor: { value: "#f3f0ff" },
        },
        _focus: {
          borderColor: { value: "{colors.brand.primary.10}" },
          boxShadow: { value: "0 0 0 3px rgba(106,92,255,.20)" },
        },
      },
      button: {
        primary: {
          backgroundColor: { value: "{colors.brand.primary.10}" },
          _hover: { backgroundColor: { value: "{colors.brand.primary.80}" } },
        },
        link: {
          backgroundColor: { value: "transparent" },
          color: { value: "{colors.brand.primary.10}" },
          borderColor: { value: "{colors.brand.primary.10}" },
          borderWidth: { value: "1px" },
          _hover: {
            backgroundColor: { value: "rgba(106,92,255,0.08)" },
          },
        },
      },
    },
    space: {
      small: { value: "8px" },
      medium: { value: "12px" },
      large: { value: "16px" },
    },
  },
};

export const darkTheme: Theme = {
  name: "custom-dark-theme",
  tokens: {
    colors: {
      background: {
        primary: { value: "#1a1535" },
        secondary: { value: "#15151d" },
      },
      brand: {
        primary: {
          10: { value: "#7b6dff" },
          20: { value: "#15151d" },
          40: { value: "#201d40" }, //table body background
          60: { value: "#1b1936" }, //table header background
          80: { value: "#9a8dff" },
          100: { value: "#16142b" }, //table background
        },
      },
      font: {
        primary: { value: "#f5f6f8" },
        secondary: { value: "#c7c7d1" },
        tertiary: { value: "#a2a2b1" },
        inverse: { value: "#1a1535" },
      },
      surface: {
        card: { value: "#FFFFFF" },
        page: { value: "#F8FAFC" },
        darkCard: { value: "#16142B" },
        darkPage: { value: "#24214A" }, //status percentage bar progress
        shadow: { value: "rgba(0, 0, 0, 0.5)" },
      },
      text: {
        primary: { value: "#111827" },
        secondary: { value: "#374151" },
        onDark: { value: "#e6e6f2" },
      },
      border: {
        primary: { value: "#2a2748" },
        secondary: { value: "#D1D1E0" },
      },
      status: {
        ok: { value: "#10B981" },
        stop: { value: "#EF4444" },
        info: { value: "#3B82F6" },
        warn: { value: "#F59E0B" },
      },
      statusBack: {
        ok: { value: "rgba(16,185,129,.12)" },
        stop: { value: "rgba(239,68,68,.12)" },
        info: { value: "#3B82F6" },
        warn: { value: "#F59E0B" },
      },
      statusBack2: {
        ok: { value: "rgba(16, 185, 129, 0.15)" },
        stop: { value: "rgba(239, 68, 68, 0.12)" },
        info: { value: "#3B82F6" },
        warn: { value: "#F59E0B" },
      },
      purple: {
        10: { value: "#F5F3FF" },
        40: { value: "#C4B5FD" },
        60: { value: "#7B66FF" },
        80: { value: "#5B4BDB" },
        100: { value: "#3C2BA8" },
      },
      link: {
        primary: { value: "#C7BFFF" },
        hover: { value: "#E0DCFF" },
        focus: { value: "rgba(123,102,255,.45)" },
      },
      muted: { value: "#b3b0d9" },
      placeholder: { value: "#8a88a8" },
      caret: { value: "#B3B0D9" },
    },
    fonts: {
      default: { variable: "NunitoSans, system-ui, sans-serif" },
    },
    radii: {
      small: { value: "10px" },
      medium: { value: "12px" },
      large: { value: "20px" },
    },
    components: {
      card: {
        backgroundColor: { value: "{colors.font.inverse}" },
        borderColor: { value: "{colors.border.primary}" },
        borderRadius: { value: "{radii.medium}" },
        padding: { value: "{space.medium}" },
      },
      fieldcontrol: {
        borderRadius: { value: "{radii.medium}" },
        borderColor: { value: "{colors.border.primary}" },
        _disabled: {
          borderColor: { value: "#3a374c" },
          backgroundColor: { value: "#3a374c" },
        },
        _focus: {
          borderColor: { value: "{colors.brand.primary.10}" },
          boxShadow: { value: "0 0 0 3px rgba(106,92,255,.20)" },
        },
      },
      authenticator: {
        router: {
          boxShadow: { value: "0 20px 60px rgba(0,0,0,.35)" },
        },
      },
      button: {
        primary: {
          backgroundColor: { value: "{colors.brand.primary.10}" },
          _hover: { backgroundColor: { value: "{colors.brand.primary.80}" } },
        },
        link: {
          backgroundColor: { value: "transparent" },
          color: { value: "{colors.brand.primary.10}" },
          borderColor: { value: "{colors.brand.primary.10}" },
          borderWidth: { value: "1px" },
          _hover: {
            backgroundColor: { value: "rgba(123,109,255,0.15)" },
          },
        },
      },
    },
    space: {
      small: { value: "8px" },
      medium: { value: "12px" },
      large: { value: "16px" },
    },
  },
};
